import React from 'react';

import { TrendFormValues } from 'features/trends/components/molecules/TrendForm/config';
import TrendFormModal from 'features/trends/components/organisms/TrendFormModal';
import { useTrends } from 'features/trends/hooks/useTrends';
import { TRENDS_LIBRARY_COPY } from 'features/trends/pages/TrendsLibrary/copy';
import { Flex } from 'shared/components/display';
import EllipticalMenu from 'shared/components/EllipticalMenu/EllipticalMenu';
import PromptButton from 'shared/components/molecules/PromptButton';

import { BUTTON_VARIANTS } from 'shared/styles/button';

import styles from './styles';

interface Props {
  showNewButton?: boolean;
  showEditButton?: boolean;
  showDeleteButton?: boolean;
  portalTarget?: string;
  trendId?: number;
  onDelete?: () => void;
  trendName?: string;
}
const TrendEllipsisMenu: React.FC<Props> = ({
  showNewButton = false,
  showEditButton = false,
  showDeleteButton = false,
  portalTarget,
  trendId,
  trendName,
  onDelete: onDeleteProp,
}) => {
  const { trend, deleteTrend, updateTrend, createTrend } = useTrends(trendId);

  const onDelete = () => {
    if (trendId) deleteTrend(trendId);
    if (onDeleteProp) onDeleteProp();
  };

  const onEditTrend = (data: TrendFormValues) => {
    const tags = data.tags.reduce<{ category: string; value: string }[]>((acc, { category, values }) => {
      values.forEach((tag) => acc.push({ value: tag, category }));
      return acc;
    }, []);
    if (trendId)
      updateTrend(trendId, {
        name: data.name,
        tags,
        fileId: data.file.id,
        deleteFile: data.file.id !== trend?.file.id,
      });
  };

  const onCreateTrend = (data: TrendFormValues) => {
    const tags = data.tags.reduce<{ category: string; value: string }[]>((acc, { category, values }) => {
      values.forEach((tag) => acc.push({ value: tag, category }));
      return acc;
    }, []);
    createTrend({
      name: data.name,
      tags,
      fileId: data.file.id,
      isBrkfstAsset: false,
    });
  };

  return (
    <Flex css={styles} className="trend-ellipsis-menu" dataCy="trend-ellipsis-menu">
      <EllipticalMenu portalTarget={portalTarget}>
        {showNewButton && <TrendFormModal onSubmit={onCreateTrend} dataCy="create-trend-modal-btn" />}
        {showEditButton && (
          <TrendFormModal
            trend={trend}
            onSubmit={onEditTrend}
            onDelete={onDelete}
            dataCy={`edit-trend-modal-btn--${trendName}`}
          />
        )}
        {showDeleteButton && (
          <PromptButton
            text={TRENDS_LIBRARY_COPY.PROMPT_DELETE_TREND}
            onConfirm={onDelete}
            variant={BUTTON_VARIANTS.OPTION}
          >
            {TRENDS_LIBRARY_COPY.BUTTON_DELETE_TREND}
          </PromptButton>
        )}
      </EllipticalMenu>
    </Flex>
  );
};

export default TrendEllipsisMenu;
